import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import './frontendFooter.css'
import '../../css/style.css'
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function FrontendFooter() {
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const navigate = useNavigate()

    useEffect(() => {
        console.log('Location changed', location, location.pathname);
    }, [location]);

    const showMenuBar = () => {
        var elem = document.getElementById("topMenuLists");
        elem.classList.toggle("addCSS");

    };


    const showMenuBarSub = () => {
        var elem = document.getElementById("topMenuLists");
        elem.classList.toggle("addCSS");

    };


    return (
        <div>



            <div className="footer_body">

                <div className="footer_logoandmenu">

                    <div className="footer_logo"> <span >  <a href="/home"><img src="https://d37pbainmkhx6o.cloudfront.net/fryright_images/footer_logo.png" alt="#" /></a>
                    </span>
                    </div>

                    <div className="footer_menu">
                        <ul>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/home');
                            }} className={splitLocation[1] === "home" ? "active" : ""}> <a>Home</a> </li>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/the-fry-right-system');
                            }} className={splitLocation[1] === "the-fry-right-system" ? "active" : ""}><a>The Fry Right System</a>
                            </li>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/boil-out-method');
                            }} className={splitLocation[1] === "boil-out-method" ? "active" : ""}><a>Boil Out method</a>
                            </li>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/testimonials');
                            }} className={splitLocation[1] === "testimonials" ? "active" : ""}><a>Testimonials</a>
                            </li>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/about-us');
                            }} className={splitLocation[1] === "about-us" ? "active" : ""}><a>About</a>
                            </li>
                            {/* <li onClick={() => {
                                showMenuBarSub()
                                navigate('/product');
                            }} className={splitLocation[1] === "product" ? "active" : ""}><a>Cart</a>
                            </li> */}
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/contact');
                            }} className={splitLocation[1] === "contact" ? "active" : ""}><a> Contact </a></li>
                            <li onClick={() => {
                                showMenuBarSub()
                                navigate('/blog');
                            }} className={splitLocation[1] === "blog" ? "active" : ""}> <a>Blog </a></li>
                           
                        </ul>
                    </div>
                </div>

                <div className="footer_social_block">

                    {/* <label>Copyright &copy; 2017 Fry Right LLC</label> */}
                    <label>Copyright @ 2017 Fry Right LLC</label>


                    <a href="https://www.facebook.com/fryrightsystem" target="_blank"><span className="fb_icon"></span></a>
                    <a href="https://twitter.com/Fry_Right" target="_blank"><span className="tw_icon"></span></a>


                </div>

                {/* <a (click)="scrollToTop()">
        <span className="scroll-to-top" [ngclassName]="{ 'show-scrollTop': windowScrolled }"></span>
    </a> */}
            </div>
        </div>
    )
}

export default FrontendFooter
